module.exports = __webpack_public_path__ + "b8afe710cc6f611b35c96a25c540ceb6.jpg";